import React from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import "./TreatOnlineSessions.css";
import RealAppointments from "../../Components/HeroSection/assets/RealAppointment.png";
import { Link } from "react-router-dom";

const TreatOnlineSessions = () => {
  return (
    <div className="card card-one-1 margin refund-policy-wrapper">
      <Navbar />
      <div className="refund-static-content">
        {/* Blog Heading */}
        <div className="static-header">
          <h1 className="container">
            Why You Need to Treat Online Sessions Like Real Appointments
          </h1>
        </div>

        {/* Blog Content */}
        <div className="container mt-4 blog-detail-wrapper">
          <img
            src={RealAppointments}
            alt="Why You Need to Treat Online Sessions Like Real Appointments"
            className="blog-detail-image"
          />

          <p className="blog-meta">
            <strong>Meta Title:</strong> Why Online Sessions Deserve the Same Respect as In Person Meetings
            <br />
            <strong>Meta Description:</strong> Don’t treat virtual sessions casually. Learn why showing up, being prepared, and staying professional matters just as much online.
          </p>

          <div className="blog-detail-content">
            <p>
              Many people assume that because a session happens online, it’s okay to be late, distracted, or unprepared.
              That mindset hurts your reputation. Whether you’re an expert or an explorer, treating online sessions like real ones sets you apart.
              Here’s why it matters and what you should do.
            </p>

            <h2>Online or Offline, It’s Still Someone’s Time</h2>
            <p>When a session is booked:</p>
            <ul>
              <li>The expert blocks their schedule.</li>
              <li>The explorer expects structured support.</li>
            </ul>
            <p>
              Missing a session or showing up late affects the experience for both sides. It creates confusion, delays progress, and wastes opportunity.
              Respect time like you would for an in person meeting.
            </p>

            <h2>First Impressions Still Count</h2>
            <p>Even though it’s virtual, your setup and attitude send a message:</p>
            <ul>
              <li>Dress decently.</li>
              <li>Join from a quiet space.</li>
              <li>Check your internet and camera before joining.</li>
            </ul>
            <p>
              People notice when you show up prepared. It builds trust fast.
            </p>

            <h2>OTP = Accountability</h2>
            <p>On UpskillMeet, the Start OTP and End OTP confirm that a session happened.</p>
            <ul>
              <li>Experts must enter these OTPs during the session.</li>
              <li>Explorers get the Start OTP in their email and the End OTP during the session.</li>
            </ul>
            <p>
              Skipping this step may delay payments and raise questions about the session’s legitimacy.
            </p>

            <h2>Be Present, Not Just Logged In</h2>
            <p>
              It’s easy to multitask or go silent on a call. But that lowers session quality. Stay focused:
            </p>
            <ul>
              <li>Turn off notifications.</li>
              <li>Keep your video on if possible.</li>
              <li>Interact actively.</li>
            </ul>
            <p>It shows you’re invested, and that matters.</p>

            <h2>Missed Sessions Create Real Impact</h2>
            <p>On UpskillMeet:</p>
            <ul>
              <li>If an explorer doesn’t show up, the expert can mark a "No Show".</li>
              <li>If an expert doesn’t show up, the explorer can do the same.</li>
            </ul>
            <p>
              This affects payment and future booking trust. Showing up reliably is one of the easiest ways to grow your presence.
            </p>

            <h2>Treat Sessions Like Commitments</h2>
            <p>If you need to reschedule or cancel:</p>
            <ul>
              <li>Raise a proper request.</li>
              <li>Give notice ahead of time.</li>
              <li>Communicate clearly.</li>
            </ul>
            <p>
              Everyone understands life happens. But being respectful about changes shows professionalism.
            </p>

            <h2>Final Thought</h2>
            <p>
              Being online doesn’t make it less important. It’s still your skill, your time, and your reputation. 
              The people who grow fastest on UpskillMeet are the ones who treat every session seriously.
            </p>
            <p>
              <Link to="/signup-options" className="join-link">Log in to manage your bookings</Link>
            </p>

            <h2>Related Reads:</h2>
            <ul>
              <li>
                <Link to="/blog/profile-that-gets-bookings">How to Build a Profile That Gets Bookings</Link>
              </li>
              <li>
                <Link to="/blog/book-better-sessionse">Using Queries to Book Better Sessions</Link>
              </li>
              <li>
                <Link to="/blog/mistakes-experts-make">Top Mistakes Experts Make on UpskillMeet</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TreatOnlineSessions;
